<template>
    <div>
        <div class="row">
            <div v-if="!BuscarIcono" class="col-lg-12">
					<div class="form-group">
						<div class="form-check form-check-inline">
							<div class="checkbox">
								<label>
									<input
										type="checkbox"
										v-model="checked"
										@change="get_DatosCli"
										name="optionsCheckboxes"
									/><span class="checkbox-material-green"
										><span class="check"></span
									></span>
									Utilizar Datos Contacto
								</label>
							</div>
						</div>
						<div class="form-check form-check-inline">
							<div class="checkbox">
								<label>
									<input type="checkbox"
									:disabled="DesactivarUsuarioMonitoreo"
									v-model="checkedScanning"
									@change="ChangeScanning"
									:checked="checkedScanning"
									name="optionsCheckboxes"
									><span class="checkbox-material-green">
										<span class="check"></span>
									</span>
									Propiedad Monitoreo Interno
								</label>
							</div>
						</div>
						<div class="form-check form-check-inline">
							<div class="checkbox">
								<label>
									<input type="checkbox"
									:disabled="DesactivarMonCliente"
									:checked="checkedMonCliente"
									v-model="checkedMonCliente"
									@change="ChangeMonCliente"
									name="optionsCheckboxes"
									><span class="checkbox-material-green">
										<span class="check"></span>
									</span>
									Client View Propiedad
								</label>
							</div>
						</div>
						<hr />
					</div>
			
					<div class="row">
						<div class="col-lg-6 ">
							<label>Nombre de la Propiedad *</label>
							<input
								type="text"
								v-model="Clientes.Nombre"
								class="form-control form-control-sm"
								placeholder="Nombre"
								id="Nombre"
								name="Nombre"
							/>
							<Cvalidation
								v-if="this.errorvalidacion.Nombre"
								:Mensaje="errorvalidacion.Nombre[0]"
							></Cvalidation>
						</div>
			
						<div class="col-lg-6 ">
							<label>Categoría </label>
							<select v-model="Clientes.Tipo" class="form-control form-control-sm">
								<option value="">Seleccione una opción</option>
								<option :value="'Cliente'">Clientes</option>
								<option :value="'Prospecto'">Prospectos</option>
								<option :value="'Suspecto'">Suspecto</option>
								<option :value="'Inactivo'">Inactivo</option>
							</select>
							<label id="lblmsuser" style="color:red"
								><Cvalidation
									v-if="this.errorvalidacion.Tipo"
									:Mensaje="errorvalidacion.Tipo[0]"
								></Cvalidation
							></label>
						</div>
			
					</div>
			
					<div class="row">
						<div class="col-lg-9">
							<label>Dirección *</label>
							<input
								type="text"
								v-model="Clientes.Direccion"
								class="form-control form-control-sm"
								placeholder="Dirección"
							/>
							<label id="lblmsuser" style="color:red"
								><Cvalidation
									v-if="this.errorvalidacion.Direccion"
									:Mensaje="errorvalidacion.Direccion[0]"
								></Cvalidation
							></label>
						</div>
			
						<div class="col-lg-3">
							<label>Distancia Aproximada (KM)</label>
							<input
								type="text"
								v-model="Clientes.DistanciaAprox"
								class="form-control form-control-sm"
								placeholder="Distancia Aproximada"
							/>
							<label id="lblmsuser" style="color:red"
								><Cvalidation
									v-if="this.errorvalidacion.DistanciaAprox"
									:Mensaje="errorvalidacion.DistanciaAprox[0]"
								></Cvalidation
							></label>
						</div>
					</div>
					
					<div class="row">
						<div class="col-lg-6">
							<label>Estado </label>
							<input
								type="text"
								v-model="Clientes.Estado"
								class="form-control form-control-sm"
								placeholder="Estado"
							/>
							<label id="lblmsuser" style="color:red"
								><Cvalidation
									v-if="this.errorvalidacion.Estado"
									:Mensaje="errorvalidacion.Estado[0]"
								></Cvalidation
							></label>
						</div>
		
						<div class="col-lg-6 ">
							<label>Ciudad *</label>
							<input
								type="text"
								v-model="Clientes.Ciudad"
								class="form-control form-control-sm"
								placeholder="Ciudad"
							/>
							<label id="lblmsuser" style="color:red"
								><Cvalidation
									v-if="this.errorvalidacion.Ciudad"
									:Mensaje="errorvalidacion.Ciudad[0]"
								></Cvalidation
							></label>
						</div>
			
					</div>
		
					<div class="row">
						<div class="col-lg-6">
							<label>Teléfono *</label>
							<input
								type="text"
								v-model="Clientes.Telefono"
								class="form-control form-control-sm"
								placeholder="Teléfono"
							/>
							<label id="lblmsuser" style="color:red"
								><Cvalidation
									v-if="this.errorvalidacion.Telefono"
									:Mensaje="errorvalidacion.Telefono[0]"
								></Cvalidation
							></label>
						</div>
		
						<div class="col-lg-6">
							<label>Estatus *</label>
							<select v-model="Clientes.Estatus" class="form-control form-control-sm">
								<option value="">Selecciona un Estatus</option>
								<option value="Activo">Activo</option>
								<option value="Inactivo">Inactivo</option>
							</select>
							<label id="lblmsuser" style="color:red"
								><Cvalidation
									v-if="this.errorvalidacion.Estatus"
									:Mensaje="errorvalidacion.Estatus[0]"
								></Cvalidation
							></label>
						</div>
					</div>
			
					<!-- <div class="row">
						<div class="col-lg-6">
							<label>Nombre del Contacto</label>
							<input
								type="text"
								v-model="Clientes.Contacto"
								class="form-control form-control-sm"
								placeholder="Contacto"
							/>
							<label id="lblmsuser" style="color:red"
								><Cvalidation
									v-if="this.errorvalidacion.ContactoS"
									:Mensaje="errorvalidacion.ContactoS[0]"
								></Cvalidation
							></label>
						</div>
			
						<div class="col-lg-6 ">
							<label>Correo </label>
							<input
								v-model="Clientes.Correo"
								class="form-control form-control-sm"
								placeholder="Correo"
							/>
							<label id="lblmsuser" style="color:red"
								><Cvalidation
									v-if="this.errorvalidacion.Correo"
									:Mensaje="errorvalidacion.Correo[0]"
								></Cvalidation
							></label>
						</div>
					</div> -->
						
			
						<!-- ESPACIO PARA LAS IMAGENES -->
						<div class="row mb-3">
							<div class="col-md-6 col-lg-6 justify-content-center text-center mt-2">
									<div class="circular_shadow">
										<img :src="pRutaIconoEmp+Clientes.IdIconoEmp" alt="">
									</div>
									<button @click="FindIcoEmp" type="button" class="btn btn-03 search02 mt-2">Buscar Icono de Edificio: {{ Clientes.IdIconoEmp }}</button>	
							</div>
				
							<div class="col-lg-6 mt-4">
								<div class="row">
									<div class="col-lg-6">
										<div class="avatar-upload-logocliente">
											<div class="avatar-preview">
												<div id="ImagePreviewLogoSucursal" :style="'background-image:url('+Clientes.LogoSucursal+');background-size:contain'" :src="Clientes.LogoSucursal">
													<!-- <div class="d-flex h-100 align-items-center justify-content-center" v-if="AltLogoSucursal">
														<h4>Logo</h4>
													</div> -->
													<!-- PONER ESTO DENTRO DEL DIV -->
													<!-- :style="'background-image: url('+Equipo.ImagenEspecificaciones+');'" :src="Equipo.ImagenEspecificaciones" -->
												</div>
											</div>
										</div>
									</div>
									<div class="col-lg-6 pl-5">
										<label title="Seleccionar Imagen" for="logosucursal" style="cursor:pointer" class="btn-icon mb-2"><i class=" mt-2 fa fa-pencil"></i></label>
										<input @change="$uploadImagePreview($event,ValidElement,Array('Img','ImagePreviewLogoSucursal'))" class="d-none" type="file" id="logosucursal" ref="logosucursal" name="logosucursal" accept=".png, .jpg, .jpeg">
										<br>
										<button @click="EliminarImagen" class="btn-icon-02"><i class="fa fa-trash"></i></button>
									</div>
								</div>
							</div>
						</div>
						
						<div class="row">
							<div class="col-lg-12 ">
								<h5>Selecciona tu ubicación</h5>
								<div class="col-12 col-sm-12 col-md-12 col-lg-12">
									<Search v-if="boleano" :oLatLng="oLatLng"></Search>
								</div>
							</div>
						</div>
						
						<!--fin col-6-->
				</div>
				<div v-else>
					<div class="row">
						<div class="col-lg-1 mb-3">
							<h4 @click="VolverFormulario" class="breadcrumb breadcrumb-item active" style="cursor:pointer;">Volver</h4>
						</div>
						<div class="col-lg-11 text-center mb-3">
							<h2>Seleccione un ícono</h2>
						</div>
					</div>
					<div class="row">
						<div v-for="(item,index) in ListaIconosEmp" :key="index" class="col-md-4 col-lg-3 mb-3">
							<div class="circular_shadow" @click="ElegirIcoEmp(index)">
								<img :src="pRutaIconoEmp+item.Imagen" alt="">
							</div>
						</div>
					</div>
			
				</div>
        </div>
        <!--Fin body del panel-->

        <div  class="modal-footer">

			<button type="button" class="btn btn-04 ban mr-2" @click="cancelForm"> Cerrar </button>

			<button type="button" class="btn btn-01" @click="Guardar">
				<i v-if="bandera" class="fa fa-spinner fa-pulse fa-1x fa-fw"></i>
				<i v-else class="fa fa-plus-circle"></i> Guardar
			</button>

        </div>
    </div>
</template>

<script>
//El props Id es cuando no es modal y se mando con props
//El export de btnsave es por si no se usa el modal
import Cbtnsave from '@/components/Cbtnsave.vue'
import Cvalidation from '@/components/Cvalidation.vue'
import Config from "@/helpers/VarConfig.js";

export default {
    name:'Form',
    props:['IdCliente','ocliente','NameList','poBtnSave','pRutaIconoEmp','pContadorPropiedades','pContadorMonCliente'],
    data() {
        return {
            Modal:true,//Sirve pra los botones de guardado
            FormName:'cliente',//Sirve para donde va regresar
			ValidElement:Config.validImage2m,
			ConfigLoad:{
				ShowLoader:false,
				ClassLoad:true
			},
            Clientes: {
				IdClienteS: "",
				IdCliente: 0,
				Nombre: "",
				Telefono: "",
				Direccion: "",
				Correo: "",
				Ciudad: "",
				Pais: "",
				Estado: "",
				CP: "",
				IdSucursal: "",
				Contacto: "",
				Dfac: "",
				Tipo: "",
				Posicion: "",
				Latitud: 0,
				Longitud: 0,
				DistanciaAprox:0,
				IdIconoEmp:"",
				LogoSucursal:"",
				CheckCli:0,
				CheckMonCli:0,
				Estatus:""
			},
            checked: false,
			checkedScanning:false,
			checkedMonCliente:false,
            urlApi:"clientesucursal/recovery",
			oLatLng: {
				Lat: 21.021320029601277,
				Lng: -89.58358390674591
			},
			boleano: true,
			RutaIconoEmp:"",
			RutaLogoSucursal:"",
            ListaContratos:[],
            showConten:true,
            ListaIconosEmp:[],
            errorvalidacion:[],
            Ruta:'',
            ImagenSelect:'',
            bandera:false,
			BuscarIcono:false,
			DesactivarUsuarioMonitoreo:false,
			DesactivarMonCliente:false
        }
    },
    components:{
        Cbtnsave,
        Cvalidation
    },
    methods :
    {
        async Guardar()
        {
			// console.log(this.$refs.logosucursal.files[0]);
			// return false;
            //deshabilita botones
            this.bandera=true;
			this.Clientes.Latitud = this.oLatLng.Lat;
			this.Clientes.Longitud = this.oLatLng.Lng;
			let formData = new FormData();

			formData.set("IdCliente", this.Clientes.IdCliente);
			formData.set("Nombre", this.Clientes.Nombre);
			formData.set("Telefono", this.Clientes.Telefono);
			formData.set("Direccion", this.Clientes.Direccion);
			formData.set("Correo", this.Clientes.Correo);
			formData.set("Ciudad", this.Clientes.Ciudad);
			formData.set("Pais", this.Clientes.Pais);
			formData.set("Estado", this.Clientes.Estado);
			formData.set("Estatus", this.Clientes.Estatus);
			formData.set("CP", this.Clientes.CP);
			formData.set("ContactoS", this.Clientes.Contacto);
			formData.set("Comentario", this.Clientes.Dfac);
			formData.set("Tipo", this.Clientes.Tipo);
			formData.set("IdClienteS", this.Clientes.IdClienteS);
			// formData.set("Posicion", this.Clientes.Posicion);
			formData.set("Latitud", this.oLatLng.Lat);
			formData.set("Longitud", this.oLatLng.Lng);
			formData.set("CheckCli", this.Clientes.CheckCli);
			formData.set("CheckMonCli", this.Clientes.CheckMonCli);

			formData.set("IdIconoEmp",this.Clientes.IdIconoEmp);
			formData.set("DistanciaAprox",this.Clientes.DistanciaAprox);
			// IMAGEN
			if (this.$refs.logosucursal.files[0]!=null) {
				let image=this.$refs.logosucursal.files[0];
				formData.append("LogoSucursal",image);
			}
			formData.set('LogoSucursalPrevio','');
			// if (this.Clientes.LogoSucursal!="" && this.Clientes.LogoSucursal!=(this.pRutaCliente.Ruta+this.oClienteP.LogoCliente)) {
			// 	let index=this.Clientes.LogoSucursal.lastIndexOf("/")+1;
			//     let cadena=this.Clientes.LogoSucursal.substr(index);
            //     formData.set('LogoSucursalPrevio',"/"+cadena);   
			// }
            // this.clientesucursal.ListaContratos=JSON.stringify(this.ListaContratos);

            await this.$http.post(
                'crmsucursal/post',
                formData,{
					headers: {
						"Content-Type": "multipart/form-data"
					}
				}
            )
            .then( (res) => {
                this.$toast.success('Información guardada');
                this.bandera=false;
                $('#ModalNewUser').modal('hide');
                this.bus.$emit('ListCliSuc',this.ocliente);
            })
            .catch( err => {
                this.errorvalidacion=err.response.data.message.errores;
                this.bandera=false;
                this.$toast.warning('Complete los campos');
            });
        },
        Limpiar() {
			(this.Clientes.Nombre = ""),
				(this.Clientes.Telefono = ""),
				(this.Clientes.Direccion = ""),
				(this.Clientes.Correo = ""),
				(this.Clientes.Ciudad = "");
			(this.Clientes.Pais = ""),
				(this.Clientes.Estado = ""),
				(this.Clientes.CP = ""),
				(this.Clientes.Contacto = ""),
				(this.Clientes.Dfac = ""),
				// (this.Clientes.IdCliente = 0),
				(this.Clientes.IdSucursal = ""),
				(this.errorvalidacion = [""]);
			this.Clientes.IdClienteS = "";
			this.Clientes.Tipo = "";
			this.Clientes.Posicion = "";
			this.Clientes.Latitud = 0;
			this.Clientes.Longitud = 0;
			this.Clientes.DistanciaAprox=0;
			this.Clientes.IdIconoEmp="",
			this.Clientes.LogoSucursal="",
			this.Clientes.CheckCli=0,
			this.Clientes.CheckMonCli=0,
			(this.Clientes.Estatus = ""),
			this.oLatLng = {
				Lat: 19.43120339928868,
				Lng: -99.13450664719238
			};

			this.checked = false;
			this.checkedScanning=false;
			this.checkedMonCliente=false;
			this.BuscarIcono=false;
			// this.ContratosAppear=false;

			// LIMPIAR LA IMAGEN
			// VERIFICAR SI ES NUEVO O SI ESTA MODIFICANDO
			$("#ImagePreviewLogoSucursal").css('background-image','url()');
			$("#ImagePreviewLogoSucursal").css('background-size','contain');
			
			// this.$refs.logosucursal.value="";
			// console.log(this.$refs.logosucursal.files[0]);
			// this.$refs.logosucursal.files[0]=undefined;
		},
        get_one()
        {
            this.$http.get(
                this.urlApi,
                {
                    params:{IdClienteS: this.clientesucursal.IdClienteS}
                }
            ).then( (res) => {
                this.clientesucursal =res.data.data.Clientes;

                this.ImagenSelect=this.clientesucursal.IdIconoEmp;
               this.checkedScanning=false;
                if(res.data.data.Clientes.CheckCli==1){
                        this.checkedScanning=true;
                }
                //CONTRATOS
                this.ListaContratos=res.data.data.ListaContratos;
            });
        },
        get_IcoEquipos()
        {
            this.$http.get(
                "iconosemp/get",
                {
                    params:{IdClienteS: this.clientesucursal.IdClienteS}
                }
            ).then( (res) => {
                //Equipos
                this.ListIconoEmp=res.data.data.iconosemp;
                this.Ruta=res.data.data.ruta;
            });
        },
        get_DatosCli() {
			if (this.checked) {
				this.Clientes.IdCliente = this.ocliente.IdCliente;
				this.Clientes.Nombre = this.ocliente.Nombre;
				this.Clientes.Direccion = this.ocliente.Direccion;
				this.Clientes.Ciudad = this.ocliente.Ciudad;
				this.Clientes.Contacto = this.ocliente.Contacto;
				this.Clientes.Telefono = this.ocliente.Telefono;
				this.Clientes.Correo = this.ocliente.Correo;
				this.Clientes.Estado=this.ocliente.Estado;
				// console.log(this.ImagenBase64(this.oClienteP.Ruta+this.oClienteP.LogoCliente));
				// this.Clientes.LogoSucursal=this.oClienteP.Ruta+this.oClienteP.LogoCliente;
				// this.$refs.logosucursal.files=this.getBase64FromUrl(this.Clientes.LogoSucursal);
			} else {
				this.Limpiar();
			}
		},
        get_scann(){
            this.clientesucursal.CheckCli=0;
            if(this.checkedScanning){
                this.clientesucursal.CheckCli=1;
            }
        },
        Add_Contratos(){
            this.ListaContratos.push({"IdContrato":'',IdClienteS:this.clientesucursal.IdClienteS,"NumeroC":'','Comentario':'',"RegEstatus":"A"});
        },
        delete_ncontrato(index){
            this.ListaContratos.splice(index, 1);
        },
        Find_IconoEmp(){
            this.showConten=false;
            this.$emit('titulomodal','Selecciona la imagen');
        },
        ReturnConten(){
            this.$emit('titulomodal','Sucursal del cliente');
            this.showConten=true;
        },
        Set_IcoEmp(index){
            this.clientesucursal.IdIconoEmp=this.ListIconoEmp[index].Imagen;
            this.ImagenSelect= this.ListIconoEmp[index].Imagen;
            this.ReturnConten();
        },
		cancelForm(){
			$('#ModalNewUser').modal('hide');
		},
		ListarIconosEmp(){
			this.$http.get('iconosemp/get',{
				params:{IdClienteS:this.Clientes.IdClienteS},
			}).then((res)=>{
				this.ListaIconosEmp=res.data.data.iconosemp;
				// console.log(this.ListaIconosEmp);
			})
		},
		ChangeScanning(){
			this.Clientes.CheckCli=0;
			if (this.checkedScanning) {
				this.Clientes.CheckCli=1;
			}
		},
		ChangeMonCliente(){
			this.Clientes.CheckMonCli=0;
			if (this.checkedMonCliente) {
				this.Clientes.CheckMonCli=1;
			}
		},
		FindIcoEmp(){
			this.BuscarIcono=true;
		},
		ElegirIcoEmp(index){
			this.Clientes.IdIconoEmp=this.ListaIconosEmp[index].Imagen;
			this.BuscarIcono=false;
		},
		VolverFormulario(){
			this.BuscarIcono=false;
		},
		EliminarImagen(){
            if (this.$refs.logosucursal.files[0]!=undefined || this.Clientes.LogoSucursal!="") {
                this.$swal({
                title: 'Esta seguro que desea eliminar esta imagen?',
                text: 'No se podra revertir esta acción',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si',
                cancelButtonText: 'No, mantener',
                showCloseButton: true,
                showLoaderOnConfirm: true
                }).then((result) => {
                    if(result.value) {
                        this.$toast.success('Información eliminada');
                        $("#ImagePreviewLogoSucursal").css('background-image','url()');
                        $("#ImagePreviewLogoSucursal").css('background-size','contain');
                        // console.log(this.$refs.logocliente.files);
                        this.$refs.logosucursal.value=null;
                        this.Clientes.LogoSucursal="";
                    } 
                });   
            }
            else{
                this.$toast.info('No hay una imagen para eliminar');
            }
        },

    },
    created() {
		this.Limpiar();
        this.Clientes.IdCliente=this.ocliente.IdCliente;
        this.bus.$off('ReturnConten');
		if (this.pContadorPropiedades<=0) {
				this.DesactivarUsuarioMonitoreo=true;
			}
			if (this.pContadorMonCliente<=0) {
				this.DesactivarMonCliente=true;
			}
        this.ListarIconosEmp();
        //Este es para modal

        this.bus.$on('ReturnConten',()=>
        {
            this.ReturnConten();
        });
    }
}
</script>
